export default __webpack_public_path__ + "static/media/menu1.3d9ce476.png";